import {
  Box,
  Flex,
  Icon,
  Image,
  Text,
  Link as LinkUI,
  useColorModeValue,
} from "@chakra-ui/react";
import { ReactTyped } from "react-typed";
import "./styles.css";
import { FaGithub, FaInstagram, FaLinkedin } from "react-icons/fa";
import { COLORS } from "../../constants/COLORS";
import ModelViewer from "../ModelViewer/ModelViewer";
import { useState } from "react";
import LoadingOverlay from "../LoadingOverlay/LoadingOverlay";

function Hero() {
  const hoverColor = useColorModeValue(COLORS.GRAY, COLORS.WHITE);
  const textColor = useColorModeValue(COLORS.DARK_BLUE, COLORS.WHITE_SMOKE);
  const [isModelLoaded, setIsModelLoaded] = useState(false);

  return (
    <Flex
      justifyContent={{ base: "center", md: "center", lg: "space-between" }}
      alignItems={"center"}
      flexWrap={"wrap"}
      mt={{ base: 10, md: 28 }}
      width={"100%"}
    >
      <LoadingOverlay isLoaded={isModelLoaded} />
      <Box
        className="intro-container"
        mt={{ base: 30, md: 30 }}
        mb={{ base: 30, md: 30 }}
        w={{ base: "100%", md: "50%" }}
      >
        {/* <Text fontSize={{ base: "1.6rem", md: "2rem" }} color="gray.600">
          Hello, my name is
        </Text> */}

        <Text
          fontSize={{ base: "3rem", md: "4rem" }}
          fontWeight="bold"
          bgClip="text"
          mb={2}
          className="name"
        >
          João Silva
        </Text>

        <Text
          fontSize={{ base: "1.2rem", md: "1.5rem" }}
          color="gray.700"
          mb={4}
          fontWeight={300}
          style={{ color: textColor }}
        >
          I design and build modern web experiences, backed by solid engineering
          and reliable analytics.
        </Text>

        {/* <Box width="fit-content" minHeight="100px">
          <Text fontSize={{ base: "1.2rem", md: "1.5rem" }} fontWeight="medium">
            <ReactTyped
              strings={["Full Stack Developer", "Mobile Developer"]}
              typeSpeed={90}
              backSpeed={50}
              loop
            />
          </Text>
        </Box> */}

        <Flex mt={{ base: 5, md: 8 }} gap={1}>
          <LinkUI
            mr={5}
            href="https://github.com/joaovff"
            target="_blank"
            onClick={() => {
              window.dataLayer?.push({
                event: "cta_click",
                cta_name: "github icon",
              });
            }}
          >
            <Icon
              as={FaGithub}
              boxSize={6}
              cursor="pointer"
              _hover={{
                color: hoverColor,
              }}
            />
          </LinkUI>
          <LinkUI
            mr={5}
            href="https://www.linkedin.com/in/joao-figueiredo-silva"
            target="_blank"
            onClick={() => {
              window.dataLayer?.push({
                event: "cta_click",
                cta_name: "likedin icon",
              });
            }}
          >
            <Icon
              as={FaLinkedin}
              boxSize={6}
              cursor="pointer"
              _hover={{
                color: hoverColor,
              }}
            />
          </LinkUI>
          {/*           <LinkUI
            mr={5}
            href="https://www.instagram.com/jota_vf"
            target="_blank"
            onClick={() => {
              window.dataLayer?.push({
                event: "cta_click",
                cta_name: "instagram icon",
              });
            }}
          >
            <Icon
              as={FaInstagram}
              boxSize={6}
              cursor="pointer"
              _hover={{
                color: hoverColor,
              }}
            />
          </LinkUI> */}
        </Flex>
      </Box>

      <Box className="model-container">
        <ModelViewer onModelLoaded={() => setIsModelLoaded(true)} />
      </Box>
    </Flex>
  );
}

export default Hero;
